export default {
  toastsList: [],
}
